<div class="container mx-auto px-4 sm:px-6 lg:px-8 py-12 max-w-6xl text-base-content">
  <div class="pt-4 pb-2">
    <black-stepper
      [section]="2"
      [steps]="['Create', 'Preview & Submit']"
    ></black-stepper>
  </div>

  <div class="flex flex-col lg:flex-row gap-8 items-stretch mt-6">
    <div
      class="flex-1 daisy-card daisy-card-bordered bg-base-100 border-base-300 text-base-content shadow-sm p-6 sm:p-8 flex flex-col justify-center items-center text-center"
    >
      <div class="w-14 h-14 rounded-full bg-success/15 text-success flex items-center justify-center mb-4 text-2xl">
        <i class="fa-solid fa-circle-check"></i>
      </div>
      <h3 class="text-xl sm:text-2xl font-bold text-base-content mb-2">
        You have successfully added your live class!
      </h3>
      @if (isAutoPublishEnabled) {
        <p class="text-sm sm:text-base text-base-content/70 mb-6 max-w-md">
          You can publish your class now so students can enroll, or keep it in
          draft until you complete your changes.
        </p>

        <div class="flex flex-col sm:flex-row gap-3 w-full max-w-xs mx-auto">
          <button routerLink="/instructor" class="daisy-btn daisy-btn-outline w-full sm:w-auto flex-1">
            Keep as Draft
          </button>
          <button (click)="publishClass()" class="daisy-btn daisy-btn-primary w-full sm:w-auto flex-1">
            Publish Live Class
          </button>
        </div>
      } @else {
        <p class="text-sm sm:text-base text-base-content/70 mb-6 max-w-md">
          You can submit your class for review when it is ready. Please keep it in
          draft until you complete your changes.
        </p>

        <div class="flex flex-col sm:flex-row gap-3 w-full max-w-xs mx-auto">
          <button routerLink="/instructor" class="daisy-btn daisy-btn-outline w-full sm:w-auto flex-1">
            Keep as Draft
          </button>
          <button (click)="submitForReview()" class="daisy-btn daisy-btn-primary w-full sm:w-auto flex-1">
            Submit for Review
          </button>
        </div>
      }
    </div>
    <div class="course-item-wrapper">
      @if (createdLiveClass !== null) {
        <black-ui-card
          [data]="createdLiveClassCard"
        ></black-ui-card>
      }
    </div>
  </div>
</div>
